<template>
	<div class="tpl activity-list-wrap">
		<mt-header title="相亲活动" fixed>
		  <router-link :to="{name:'finds'}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button class="my-activity-btn" @click.native="goToMyActivity" icon="more" slot="right"></mt-button>
		</mt-header>
		<div class="list-filter">
			<span class="btn add-filter-btn" :class="{'active':filterValue=='1'}" @click="filterList('1')">{{nowAddress}} <img src="../../assets/img/finds/ic_find_list_pdl_nor@2x.png"/></span>
			<span class="btn other-filter-btn" :class="{'active':filterValue=='2'}" @click="filterList('2')">筛选<img v-if="filterValue!='2'" src="../../assets/img/finds/ic_find_list_filter_nor@2x.png"/><img v-else src="../../assets/img/finds/ic_find_list_sel_per@2x.png"/></span>
		</div>
		<div class="other-filter-wrap" v-if="filterValue=='2'">
			<ul>
				<li :class="{'active':isFee=='0'}" @click="chooseOtherFilter('isFee','0')">免费活动 <img src="../../assets/img/finds/ic_find_list_sel@2x.png"/></li>
				<li :class="{'active':isFee=='1'}" @click="chooseOtherFilter('isFee','1')">收费活动 <img src="../../assets/img/finds/ic_find_list_sel@2x.png"/></li>
				<li :class="{'active':status=='1'}"  @click="chooseOtherFilter('status','1')">进行中 <img src="../../assets/img/finds/ic_find_list_sel@2x.png"/></li>
				<li :class="{'active':status=='3'}"  @click="chooseOtherFilter('status','3')">已结束 <img src="../../assets/img/finds/ic_find_list_sel@2x.png"/></li>
			</ul>
		</div>
		<div class="activity-list">
			<mt-loadmore :top-method="refreshActivityList" :bottom-method="loadMoreActivityList" :auto-fill="false" ref="loadmore">
				<list-item :itemInfo="item" v-for="(item,index) in listInfo" :key="index"></list-item>
				<div class="no-content" v-if="!listInfo">
					<img src="../../assets/img/default/bg_img_empty@2x.png"/>
					<p>(〃'▽'〃)这里空空哒~</p>
				</div>
			</mt-loadmore>
			
		</div>
		<get-position @getPosition="getPosition"></get-position>
	</div>
</template>

<script>
	
	import ListItem from "./ActivityListItem"
	import GetPosition from '../Common/GetPosition'
	export default{
		name:"activity-list",
		components:{
			ListItem,
			GetPosition
		},
		data(){
			return{
				uid:"",
				nowAddress:"",
				nowPage:1,
				isFee:"",
				status:"",
				listInfo:"",
				filterValue:"0",	//当前筛选选项
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.nowAddress = this.$route.params.add || this.$store.state.nowAddress;	//获取用户地址
			console.log(this.nowAddress);
			
			this.getListInfo();
		},
		watch:{
			filterValue(){
				if(this.filterValue==1){
					this.$router.push({
						name:"choose-address",
						params:{nowAdd:this.nowAddress}
					})
					
				}
			},
		},
		methods:{
			getPosition(data){
				console.log(data);
				this.$store.commit("setNowAdd", data.name);
			},
			filterList(v){
				if(this.uid){
					if(this.filterValue == v){
						this.filterValue = 0;
					}else{
						this.filterValue = v;
					}
				}else{
					this.$toast({
						message:"请登录！",
						position:"bottom",
						duration:3000
					})
				}
				
			},
			chooseOtherFilter(n,v){
				if(this[n]!=v){
					console.log(this[n]);
					this[n]=v
				}else{
					this[n]=''
				}
				this.filterValue="0";
				this.getListInfo();
			},
			getListInfo(){
				this.$axios({
					url:"Appointment/EnrollActivityList",
					method:"post",
					data:{
						page:this.nowPage,
						registration_fee:this.isFee,
						address:this.nowAddress.name,
						status:this.status
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.nowPage==1){
							this.listInfo = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.nowPage--;
							}else{
								this.listInfo = this.listInfo.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.nowPage--;
					}
				}).catch(err=>{
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"加载超时，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			goToMyActivity(){
				this.$router.push({
					name:"my-activity-list"
				})
			},
			refreshActivityList(){
				this.nowPage = 1;
				this.getListInfo();
				this.$refs.loadmore.onTopLoaded();
				
			},
			loadMoreActivityList(){
				this.nowPage ++;
				this.getListInfo();
				this.$refs.loadmore.onBottomLoaded();
			}
		}
	}
</script>

<style scoped>
	.my-activity-btn >>>.mint-button-icon{
		width: 1.8rem;
		height: 1.8rem;
		margin-top: 0.3rem;
		background: url(../../assets/img/finds/ic_find_nav_sign@2x.png) no-repeat;
		background-size: contain;
		color: transparent;
	}
	.activity-list-wrap{
		padding-top: 5.5rem;
	}
	.activity-list{
		overflow-y: scroll;
		height: calc(100vh - 5.5rem);
		background: #fff;
	}
	
	.list-filter{
	    position: fixed;
	    width: 100%;
	    top: 2.5rem;
	    left: 0;
	    font-size: 1rem;
	    font-weight: bold;
	    display: flex;
	    justify-content: space-between;
	    padding: 0.5rem;
	    line-height: 2rem;
	    color: #282828;
	    z-index: 10;
	    background: #fff;
	    border-bottom: 1px solid #f3f3f3;
	}
	.list-filter .btn{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	    padding: 0 0.5rem;
	}
	.list-filter .btn img{
		width: 1.6rem;
	}
	.list-filter .btn.active{
		color: #7644FA;
	}
	.list-filter .add-filter-btn.active img{
		transform: rotate(180deg);
	}
	
	.other-filter-wrap{
		background: #fff;
	    position: absolute;
	    z-index: 10;
	    width: 100%;
	    left: 0;
	    padding: 1rem;
	}
	.other-filter-wrap li{
		display: flex;
	    justify-content: flex-start;
	    align-items: center;
	    color: #282828;
	    line-height: 3rem;
	    font-size: 1rem;
	}
	.other-filter-wrap li img{
		width: 1.5rem;
		display: none;
	}
	.other-filter-wrap li.active{
		color: #a98dfc;
	}
	.other-filter-wrap li.active img{
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/ActivityList.vue